import { Flex, Group, Paper, Stack, Text } from '@mantine/core';

import { AliasAddButton } from '@/module/Dashboard/components/AliasAddButton';
import { AliasPill } from '@/module/Dashboard/components/AliasPill';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';

import { UpdateProfileButton } from './components/UpdateProfileButton';

export interface AliasListProps {
  profileDetails: ProfileDetails;
}

export function AliasList({ profileDetails }: AliasListProps) {
  const { name, email, aliases } = profileDetails;

  return (
    <Paper
      flex={1}
      p="md"
      mih="200px"
    >
      <Stack>
        <Flex justify="space-between">
          <div>
            <Text>Nume: {name}</Text>
            <Text>Email: {email}</Text>
          </div>
          <AliasAddButton />
          <UpdateProfileButton />
        </Flex>
        <Text>Aliasuri revendicate:</Text>
        <Group>
          {aliases.map(alias => (
            <AliasPill
              key={alias}
              alias={alias}
            />
          ))}
        </Group>
      </Stack>
    </Paper>
  );
}
